import React, { Component } from 'react';
import getLocale from '../../../i18n/getLocale';

class ScheduleGradeInitialsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      initials: this.props.initials,
    };

    this.locale = getLocale();
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.initials)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        initials: newProps.initials,
        loaded: 1,
      });
    }
  }



  render() {
    var self = this;
    return (
<div>
  <h3 className="page-title">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSiglas.tituloSiglas}</h3>
  <hr/>
  {(this.state.initials === null || typeof this.state.initials === 'undefined') ?  <div><small><em>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSiglas.nenhumaSiglaCadastrada}</em></small><hr/></div>
  :
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSiglas.tabela.Sigla}</th>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSiglas.tabela.Diaria}</th>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSiglas.tabela.Nome}</th>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSiglas.tabela.Descricao}</th>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabSiglas.tabela.Treinamento}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.initials).map(function(k) {
          return (
            <tr>
              <td>{self.state.initials[k].name}</td>
              <td className="text-center">{self.state.initials[k].diaria_str}</td>
              <td>{self.state.initials[k].fullname}</td>
              <td>{self.state.initials[k].description}</td>
              <td className="text-center">{self.state.initials[k].training_str}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }

</div>
    );
  }
}


export default ScheduleGradeInitialsTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeInitialsTab.js